import { render, staticRenderFns } from "./ItemViewMessage.vue?vue&type=template&id=7bdb84ab&"
import script from "./ItemViewMessage.vue?vue&type=script&lang=ts&"
export * from "./ItemViewMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports